export const placeholderClasses = {
    primary: 'placeholder:text-slate-400 dark:placeholder:text-neutral-600',
    secondary: 'placeholder:text-neutral-400 dark:placeholder:text-neutral-600',
    danger: 'placeholder:text-danger-300',
    transparent: 'placeholder:text-slate-400 dark:placeholder:text-neutral-600',
};
